import Vue from 'vue';
import MediaPreviewVue from './MediaPreview.vue';

const MediaPreviewConstructor = Vue.extend(MediaPreviewVue);

let nId = 1;

const MediaPreview = (mediaList, currentIndex = 0, type = 'image') => {
    let id = 'media-preview-' + nId++;
    const MediaPreviewInstance = new MediaPreviewConstructor({
        data: {
            type,
            mediaList,
            currentIndex
        }
    });

    MediaPreviewInstance.id = id;
    MediaPreviewInstance.vm = MediaPreviewInstance.$mount();
    MediaPreviewInstance.vm.visible = true;
    MediaPreviewInstance.dom = MediaPreviewInstance.vm.$el;
    document.body.appendChild(MediaPreviewInstance.dom);
    // document.body.removeChild(MediaPreviewInstance.dom);
    MediaPreviewInstance.dom.style.zIndex = nId + 1001;
    return MediaPreviewInstance.vm;
};

export default {
    install: Vue => {
        Vue.prototype.$MediaPreview = MediaPreview;
    }
};
